import { useRunPayrollDataContext } from 'components/RunPayroll/contexts/RunPayrollDataContext';

/**
 * Can be used only inside RunPayrollDataContext
 */
export const useIsPayPtEnabled = () => {
  const data = useRunPayrollDataContext();

  return !!data?.hasKaptPayments;
};
